import { styled } from '@mui/system';

const NavigationRoot = styled('div')(() => ({
    background: '#323232',
    height: '100%',
    overflowX: 'hidden',
    color: '#e0e0e0',
}));

const LinkStyle = {
    textDecoration: 'none',
    // Force link color in all states (unvisited, visited, active, focus)
    color: '#e0e0e0',
    '&, &:link, &:visited, &:active, &:focus': {
        color: '#e0e0e0',
    },
    // Ensure nested text and icons inherit the same color
    '& .MuiListItemText-root, & .MuiListItemText-root .MuiTypography-root': {
        color: '#e0e0e0',
    },
    '& .MuiListItemIcon-root, & .MuiListItemIcon-root svg': {
        color: '#e0e0e0',
    },
    '&:hover': {
        background: 'rgba(255, 255, 255, 0.1)',
        textDecoration: 'none',
    },
};

export { NavigationRoot, LinkStyle };
